<template>
  <div id="aa" >
    <Header />
	<Menu  @getLoading="loading = $event" />
	<Content v-loading="loading" />
  </div>
</template>

<script>

import Header from './Header.vue'
import Menu from './Menu.vue'
import Content from './Content.vue'
export default {
	data(){
		return{
			loading:false,
		}
	},
	components:{
		Header,
		Menu,
		Content		
	},
  methods:{   
  },
  created(){   
  }
 
}
</script>

<style>

#aa {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
 color: #141618;
 text-decoration: none !important;
  display: grid;
  grid-template-rows: 65px 1fr ;
  grid-template-columns:  290px 1fr;
	grid-template-areas: 
	"menu header"
	"menu content"
	
}


</style>
